
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon i-download",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","stroke":"currentColor","fill":"transparent","class":"icon i-download"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"i-download__ground",attrs:{"d":"M2.03 15.18h13.94"}}),_c('path',{attrs:{"d":"M4.64 7.2L9 11.56l4.36-4.36M9 1.97v9.59"}})])
          )
        }
      }
    